/* eslint-disable */
import { createRouter, createWebHistory } from "vue-router";
import Dashboard from "../views/Dashboard/Dashboard.vue";
import Signup from "../views/Signup.vue";
import Signin from "../views/Signin.vue";
import perfil from "../views/Perfil.vue";
import editarPerfil from "../views/Dashboard/EditarPerfil.vue";
import NotFound from "../views/404.vue";
import Venta from "../views/Venta.vue";
import Landing from "../views/Landing.vue";
import DatosBancarios from "../views/DatosBancarios.vue";
import Terminos from "../views/Terminos.vue";
import Descripcion from "../views/Descripcion.vue";
import store from "@/store/index";
import Referidos from "../views/Referidos/Index.vue";
import Mas from "../views/Mas.vue";
import Register from "../views/Register.vue";
import transacciones from "../views/Dashboard/Transacciones.vue";
import detalleVentas from "../views/Dashboard/DetalleVentas.vue";
import Administracion from "../views/Administracion/Index.vue";
import estadisticas from "../views/Dashboard/Estadisticas.vue";
import detalleCredencial from "../views/Dashboard/DetalleCredencial.vue";
import recursos from "../views/Dashboard/Recursos.vue";
import premios from "../views/Dashboard/Premios.vue";
import Desuscribirse from "../views/Desuscribirse.vue";
import authGuard from "./authGuard";

const routes = [
  {
    path: "/",
    name: "landing",
    component: Signin,
    meta: { layout: "full" },
  },
  {
    path: "/login",
    name: "Signin",
    component: Signin,
    meta: { layout: "full" },
  },
  {
    path: "/dashboard/referidos",
    name: "referidos",
    component: Referidos,
    meta: {
      requiresAuth: true,
      layout: "horizontal",
      breadCrumb: "Mi Equipo Saludsa Refiere y Gana",
    },
  },
  {
    path: "/dashboard/banco",
    name: "banco",
    component: DatosBancarios,
    meta: {
      requiresAuth: true,
      layout: "horizontal",
      breadCrumb: "Cuenta bancaria",
    },
  },
  {
    path: "/dashboard/mas",
    name: "mas",
    component: Mas,
    meta: {
      requiresAuth: true,
      layout: "horizontal",
      breadCrumb: "Otras opciones",
    },
  },
  {
    path: "/dashboard/terminos",
    name: "terminos",
    component: Terminos,
    meta: {
      requiresAuth: true,
      layout: "horizontal",
      breadCrumb: "Términos y condiciones",
    },
  },
  {
    path: "/dashboard/terminos-saludsa",
    name: "terminos-saludsa",
    component: Descripcion,
    meta: {
      requiresAuth: true,
      layout: "horizontal",
      breadCrumb: "Términos de Saludsa Refiere y Gana",
    },
  },
  {
    path: "/venta/:promoCode?",
    name: "Venta",
    component: Venta,
    meta: { layout: "full" },
  },
  {
    path: "/dashboard",
    name: "Dashboard",
    component: Dashboard,
    meta: { requiresAuth: true, layout: "horizontal", breadCrumb: "Inicio" },
  },
  {
    path: "/administracion",
    name: "Administracion",
    component: Administracion,
    meta: {
      requiresAuth: true,
      layout: "horizontal",
      breadCrumb: "Administración",
      requiredRole: ["administrador"],
    },
  },
  {
    path: "/desuscribirse",
    name: "Desuscribirse",
    component: Desuscribirse,
    meta: { layout: "full" },
  },
  {
    path: "/signup",
    name: "Signup",
    component: Signup,
    meta: { layout: "full" },
  },
  {
    path: "/perfil",
    name: "Perfil",
    component: editarPerfil,
    meta: {
      requiresAuth: true,
      layout: "horizontal",
      breadCrumb: "Editar perfil",
    },
  },
  {
    path: "/register",
    name: "Register",
    component: Register,
    meta: { requiresAuth: true, layout: "full" },
  },
  {
    path: "/:catchAll(.*)",
    name: "NotFound",
    component: NotFound,
    meta: { layout: "full" },
  },
  {
    path: "/dashboard/transacciones",
    name: "transacciones",
    component: transacciones,
    meta: {
      requiresAuth: true,
      layout: "horizontal",
      breadCrumb: "Mis transacciones",
    },
  },
  {
    path: "/dashboard/ventas",
    name: "ventas",
    component: detalleVentas,
    meta: {
      requiresAuth: true,
      layout: "horizontal",
      breadCrumb: "Mis ventas",
    },
  },
  {
    path: "/dashboard/credencial",
    name: "credencial",
    component: detalleCredencial,
    meta: {
      requiresAuth: true,
      layout: "horizontal",
      breadCrumb: "Credencial",
    },
  },
  {
    path: "/dashboard/recursos",
    name: "recursos",
    component: recursos,
    meta: {
      requiresAuth: true,
      layout: "horizontal",
      breadCrumb: "Recursos",
    },
  },
  {
    path: "/dashboard/premios",
    name: "premios",
    component: premios,
    meta: {
      requiresAuth: true,
      layout: "horizontal",
      breadCrumb: "Premios",
    },
  },
  {
    path: "/dashboard/estadisticas",
    name: "estadisticas",
    component: estadisticas,
    meta: {
      requiresAuth: true,
      layout: "horizontal",
      breadCrumb: "Estadisticas",
    },
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  linkActiveClass: "active",
});

// Clean router guards using auth guard
router.beforeEach(async (to, from, next) => {
  // Handle login/landing page redirects
  if (to.path === "/login" || to.path === "/") {
    await authGuard.handleLoginRedirect(to, from, next);
    return;
  }

  // Handle all other routes
  await authGuard.guard(to, from, next);
});

export default router;
